<template>
  <div class="ticket-form" v-loading="loading || loadingProject">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title"><i class="ti-ticket"></i> Novo Ticket </h4>
      </div>

      <div class="card-content">
        <div class="row">
          <div class="col-md-4">
            <label>Evento</label>
            <select
              v-model="model.eventId"
              id="id-event"
              name="eventId"
              @change="handleSelectEvent()"
              v-validate="modelValidations.eventId"
              class="form-control"
            >

              <option value=""> Selecione ...</option>

              <option
                v-for="events in eventsOptions"
                :key="events.value"
                :value="events.value"
              > {{ events.label }}
              </option>
            </select>

            <small class="text-danger" v-show="eventId.invalid"> {{
              getError('eventId') }}
            </small>
          </div>

          <div class="col-md-4">
            <label for="barcode">Código do Ticket</label>
            <input
              :readonly="config.ticket.automaticBarcode"
              id="barcode"
              class="form-control"
              name="barcode"
              v-validate="modelValidations.barcode"
              v-model="model.barcode"
            />

            <small class="text-danger" v-show="barcode.invalid">
              {{ getError('barcode') }}
            </small>
          </div>
        </div>
      </div>

      <div class="card-footer text-right">
        <button
          type="button"
          :disabled="saving || !model.eventId || model.eventId === ''"
          @click="handleCreateTicket()"
          class="btn btn-wd btn-fill btn-success btn-sm"
        > Gerar Ticket
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import swal from 'sweetalert2'
  import {mapFields} from 'vee-validate'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'TicketForm',

    props: {
      customer: {required: true, type: Object},
      ticketLoaded: {type: Boolean},
      winnerLoaded: {type: Boolean},
      tickets: {}
    },

    data () {
      return {
        saving: false,
        isWinnerTrgOlder: false
      }
    },

    watch: {
      eventSelected () {
        this.$nextTick(() => {
          this.setTicketBarcode()
        })
      },

      customer () {
        this.$nextTick(() => {
          this.setTicketBarcode()
        })
      },

      winner () {
        this.$nextTick(() => {
          this.checkWinnerOld()
        })
      }
    },

    methods: {
      ...mapActions('project', {
        fetchProject: 'fetchOne'
      }),
      ...mapActions('tickets', {
        resetOne: 'resetOne',
        createTicket: 'createTicket',
        updateDefaultModel: 'updateDefaultModel'
      }),

      ...mapActions(['setEventSelected']),

      handleCreateTicket () {
        this.saving = true
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveNewTicket()
          }
        })
      },

      saveNewTicket () {
        const { _id: userId } = JSON.parse(localStorage.getItem('user'))
        let doc = Object.assign({}, this.model)
        doc.collection = 'tickets'
        doc.customerId = this.customer._id
        doc.winner = false
        doc.eligible = this.isEligible
        doc.reasonNotEligible = !this.isEligible ? 'Já foi contemplado anteriormente.' : ''
        doc.userId = userId
        this.createTicket(doc)
          .then(result => {
            // this.saving = false
            if (result.ticketCreated) {
              this.$notify({
                message: result.message,
                type: 'success'
              })
              this.setEventId()
              this.$emit('on-ticket-create', {})
            } else {
              swal({
                title: 'Ocorreu um erro.',
                text: result.message,
                type: 'error',
                confirmButtonClass: 'btn btn-info btn-fill',
                buttonsStyling: false
              })
            }
          })
          .finally(e => {
            this.saving = false
          })
      },

      handleSelectEvent () {
        this.setEventSelected(this.model.eventId)
        this.setTicketBarcode()
      },

      setTicketBarcode () {
        this.model.barcode = `${this.customer.uc}${_.random(10000000, 99999999)}`
        return this.updateDefaultModel({ barcode: this.model.barcode })
      },

      setEventId () {
        if (this.eventSelected.hasOwnProperty('_id')) {
          this.model.eventId = this.eventSelected._id
          return this.updateDefaultModel({ eventId: this.eventSelected._id })
        }
      },

      getError (fieldName) {
        return this.errors.first(fieldName)
      },

      checkWinnerOld () {
        let uc = this.config.validationContemplatedCustomer.uc && this.winner ? this.customer.uc === this.winner.uc : false

        let cpf = this.config.validationContemplatedCustomer.cpf && this.winner ? this.customer.cpf.replace(
          /\D/g,
          ''
        ) === this.winner.cpf : false

        let validPeriod = false
        if (this.winner && this.winner.exchangeDate !== '') {
          let period = parseInt(this.config.event.contemplatedPeriod)
          let currentYear = parseInt((new Date()).getFullYear())
          let exchangedAt = parseInt((new Date(this.winner.exchangeDate)).getFullYear())

          validPeriod = (exchangedAt + period) < currentYear
        }

        this.isWinnerTrgOlder = this.config.validationContemplatedCustomer.uc && this.config.validationContemplatedCustomer.cpf ? uc && cpf && !validPeriod : (uc || cpf) && !validPeriod
      }
    },

    computed: {
      ...mapFields(['eventId', 'barcode']),

      ...mapGetters('project', {
        config: 'project',
        loadingProject: 'loading'
      }),

      ...mapGetters(['eventSelected']),

      ...mapGetters('events', {
        eventsOptions: 'startedOptions'
      }),

      ...mapGetters('tickets', {
        model: 'ticket',
        modelValidations: 'validations',
        loading: 'loading'
      }),

      winner: {
        get () {
          if (this.$store.state.winners.all.lenght > 0) {
            return this.$store.state.winners.all[0]
          }
          return {}
        }
      },
      // ...mapGetters('winners', ['winner']),

      isWinnerTrgNewer: function () {
        if (this.tickets && this.tickets.length > 0) {
          return this.tickets.find(item => item.winner) !== undefined
        } else {
          return false
        }
      },

      isEligible: function () {
        return !this.isWinnerTrgNewer && !this.isWinnerTrgOlder
      }
    },

    mounted () {
      if (!this.config.hasOwnProperty('_id')) {
        this.fetchProject('config')
      }
      if (this.customer) {
        this.setTicketBarcode()
      }

      this.setEventId()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/TicketForm.vue